import { Select, SelectItem } from '@heroui/react';
import _ from 'lodash';
import type { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useFetchStatesQuery } from '@/slices/state-api-slice.ts';
import type { StateModel } from '../types/address.type.ts';
import type { FormControlProps } from '../types/form-props.type.ts';

export const StateSelect: FC<FormControlProps> = ({
  name,
  label = 'State',
  disabled,
  required,
  displayProperty = 'name',
  validatorFn,
}) => {
  const { data, isLoading } = useFetchStatesQuery();
  const { control } = useFormContext();

  const validateState = (value: any, formValues: any) => {
    if (validatorFn) {
      const result = validatorFn(value, formValues);
      if (result !== undefined) {
        return result;
      }
    }

    if (required && !value?.id) {
      return 'This field is required';
    }

    return true;
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        validate: validateState,
      }}
      render={({ field, fieldState }) => (
        <Select
          label={label}
          variant='bordered'
          isRequired={required}
          isDisabled={disabled}
          isLoading={isLoading}
          isInvalid={fieldState.invalid}
          errorMessage={fieldState.error?.message}
          items={data || []}
          selectedKeys={field.value?.id ? [field.value.id.toString()] : []}
          onSelectionChange={keys => {
            const selectedId = Array.from(keys)[0];
            if (selectedId) {
              const selectedState = data?.find(x => x.id === parseInt(selectedId as string));
              field.onChange(selectedState);
            } else {
              field.onChange(null);
            }
          }}
        >
          {(item: StateModel) => (
            <SelectItem key={item.id.toString()} textValue={_.get(item, displayProperty)}>
              {_.get(item, displayProperty)}
            </SelectItem>
          )}
        </Select>
      )}
    />
  );
};
